<template>
  <BaseExportContact
    :showSelectBuilding="false"
    postFixer="work-permits"
  >
    <HKLForm
      slot="addtional-content"
      ref="formRef"
      class="export-work-permits-search"
    >
      <div class="issue-date-range">
        <label class="emphasis ad-search-condition-label">
          {{ $t('project.building') }}
        </label>
        <HKLMultiSelect
          v-model="selectedBuildings"
          class="check-valid building-option"
          :required="true"
          :showTip="false"
          :options="buildingOptions"
        />
      </div>
    </HKLForm>
  </BaseExportContact>
</template>

<script>
import { computed, ref, unref } from 'vue-demi'
import lodash from 'lodash'
import BaseExportContact from '@/pages/ccd/BaseExportContact'
import HKLMultiSelect from '@/controls/Select/HKLMultiSelect.vue'
import { useStoreGetters } from '@/store/index'
import HKLForm from '@/controls/Form/HKLForm.vue'
import { useRefForm } from '@/controls/Form/hook'
import { exportWorkPermits } from '../../api/workPermit/request'

export default {
  components: {
    BaseExportContact,
    HKLMultiSelect,
    HKLForm,
  },
  setup () {
    const { currentUserBuildings } = useStoreGetters('user', ['currentUserBuildings'])
    const { form: formRef, validate: formValidate } = useRefForm()

    const selectedBuildings = ref([])
    const buildingRequired = ref(false)

    const buildingOptions = computed(() => {
      const result = unref(currentUserBuildings)
        .map(building => ({name: building.code, value: building.id}))
      return lodash.uniqBy(result, 'value')
    })
    const exportData = async () => {
      if (!formValidate()) {
        return
      }
      await exportWorkPermits({ buildingIds: unref(selectedBuildings) })
    }
    const exportBtn = computed(() => {
      return {
        actionTitle: 'export',
        func: unref(exportData),
      }
    })
    return {
      exportBtn,
      selectedBuildings,
      buildingOptions,
      buildingRequired,
      formRef,
    }
  },
}
</script>

<style lang="scss" scoped>
.export-work-permits-search {
  display: flex;
  .building-option {
    width: 240px;
    margin-right: 50px;
    ::v-deep .ant-select-selection {
      min-height: 38px;
      .ant-select-selection__rendered {
        min-height: 38px;
      }
    }
  }
}
</style>
